export const LoginEvent = Symbol('login')
